import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
  background-color: var(--p-bg);
  color: var(--p-text-color);
}

:host([dark]) {
  background-color: var(--p-bg-dark);
  color: var(--p-text-color-light);
}

.video-page {
  padding: var(--p-gap) 0 var(--p-section-padding);
}

.container {
  width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
  margin-inline: auto;
}

@media (max-width: 768px) {
  .video-page {
    padding-top: 0;
  }
  .container {
    width: 100%;
  }
}

/**
--------------------------------------------------
* Player
--------------------------------------------------
*/
.player {
  max-height: calc(100svh - calc(var(--p-header-height) + var(--p-gap) * 2));
  aspect-ratio: 16/9;
  width: 100%;
  position: relative;
}

.mf-livewait{
  padding-top: 0;
}

slot[name="player"]::slotted(*) {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

/**
--------------------------------------------------
* Info
--------------------------------------------------
*/
.info {
  padding-top: var(--p-gap);
  display: grid;
  gap: var(--p-gap);
  grid-template-columns: 3fr 2fr;
}

h1 {
  font-family: var(--p-h1-font);
  font-size: var(--p-h1-font-size);
  font-weight: var(--p-h1-font-weight);
  font-style: var(--p-h1-font-style);
  line-height: var(--p-h1-line-height);
  text-transform: var(--p-h1-transform);
  letter-spacing: var(--p-h1-letter-spacing);
  margin: 0;
}

.meta {
  display: flex;
  gap: .5rem;
  align-items: center;
  flex-wrap: wrap;
  margin: .5rem 0 1rem;
  font-size: 1rem;
}

.meta time {
  opacity: var(--p-text-meta-opacity);
}

.meta .viewers {
  display: flex;
  gap: .25rem;
  align-items: center;
  font-weight: bold;
}


.description {
  max-width: var(--p-text-max-width);
  font-family: var(--p-preamble-font);
  font-size: var(--p-preamble-font-size);
  font-weight: var(--p-preamble-font-weight);
  font-style: var(--p-preamble-font-style);
  line-height: var(--p-preamble-line-height);
  letter-spacing: var(--p-preamble-letter-spacing);
  margin: 0;
  white-space: pre-line;
}

.data {
  margin: var(--p-gap) 0 0 auto;
  padding: var(--p-gap);
  border-radius: var(--p-video-data-border-radius, 10px);
  max-width: 400px;
  background-color: var(--p-bg-light);
  --p-p-margin-bottom: 0;
}


:host([dark]) .data {
  background-color: var(--p-text-color-light-contrast-100);
}

@media (max-width: 768px) {
  .info {
    grid-template-columns: 1fr;
    padding-inline: var(--p-gap);
  }

  .data {
    margin: var(--p-gap) 0 0 0;
    max-width: 100%;
  }
}

.hide-data .data {
  display: none;
}

/**
--------------------------------------------------
* Actions
--------------------------------------------------
*/
.actions {
  display: flex;
  gap: .5rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .actions {
    justify-content: flex-start;
  }
}

/**
--------------------------------------------------
* Theater Mode
--------------------------------------------------
*/
.theater-mode.video-page {
  padding-top: 0;
}

.theater-mode .container{
  width: 100%;
}

.theater-mode .info {
  padding-inline: var(--p-gap);
}

.theater-mode .player {
  max-height: calc(100svh - calc(var(--p-header-height)));
}

`;
